module.exports = __webpack_public_path__ + "img/Pureserv1.18290741.png";